import { createIcon } from '@chakra-ui/icons';
import React from 'react';
export const MinusIcon = createIcon({
    displayName: 'MinusIcon',
    viewBox: '0 0 24 24',
    path: (React.createElement("path", { d: "M6.25 12.75C6.0375 12.75 5.85938 12.6781 5.71563 12.5343C5.57188 12.3905 5.5 12.2123 5.5 11.9997C5.5 11.7871 5.57188 11.609 5.71563 11.4654C5.85938 11.3218 6.0375 11.25 6.25 11.25H17.75C17.9625 11.25 18.1406 11.3219 18.2843 11.4657C18.4281 11.6095 18.5 11.7877 18.5 12.0003C18.5 12.2129 18.4281 12.391 18.2843 12.5346C18.1406 12.6782 17.9625 12.75 17.75 12.75H6.25Z", fill: "currentColor" })),
});
